import React, { Component } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import {
  Tab,
  Nav,
  ToggleButton,
  ButtonGroup,
  ListGroup,
  Container,
  Row,
  Stack,
  Dropdown,
  Form,
} from "react-bootstrap";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactDOM from "react-dom";
import { Carousel } from "react-responsive-carousel";
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'
import { connect } from "react-redux";
import {
  insertMemberRegistration_action,
  getMemberRegistration_action,
  getIncompleteMemberRegistration_action,
} from "../../../actions/staticAction/registration_action";
import {
  toastError,
  toastSuccess,
  countryActionId,
  cityActionId,
  industryActionId,
  stateActionId,
  pincodeActionId,
  BASE_URL,
} from "../../../utils/constants";
import { fill_action } from "../../../actions/fillCombo_action";
import $ from "jquery";
import {
  contactNoValidator,
  panNoValidator,
  tanNoValidator,
  gstNoValidator,
  emailValidator,
} from "../../../utils/Validator";
import { countDownDate_action } from "../../../actions/staticAction/static_action";
import moment from "moment";
import { Modal } from "react-bootstrap";

class CompanyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOtherPreName: false,
      MemberID: "",
      MembershipNo: "",
      prename: "Mr",
      otherName: "",
      companyName: "",
      companywebsite: "",
      industryId: "",
      yearOfEstablishment: "",
      companyAdd1: "",
      companyAdd2: "",
      city: "",
      regstate: "",
      countryId: 91,
      contactPerson: "",
      designation: "",
      emailId: "",
      phone: "",
      prephone: "",
      stateId: "",

      sameAsCorrespondence: false,
      isOpenDropDownState: false,
      focusedIndexState: -1,
      isOpenDropDownCity: false,
      focusedIndexCity: -1,
      invisOpenDropDownState: false,
      invfocusedIndexState: -1,
      invisOpenDropDownCity: false,
      invfocusedIndexCity: -1,
      tempCityList: [],
      tempStateList: [],
      cityList: [],
      stateList: [],
      countryList: [],
      industryList: [],
      invisOtherPreName: false,
      invprename: "Mr",
      invotherName: "",
      invcompanyName: "",
      invcompanywebsite: "",
      invindustryId: "",
      invyearOfEstablishment: "",
      invcompanyAdd1: "",
      invcompanyAdd2: "",
      invcity: "",
      invregstate: "",
      invcountryId: 91,
      invcontactPerson: "",
      invdesignation: "",
      invemailId: "",
      invphone: "",
      invprephone: "",
      AccountID: "",
      namePrefix: ["Mr", "Ms", "DR", "Prof"],

      // Verifier Details
      verifierFirstName: "",
      verifierLastName: "",
      verifierEmailId: "",
      verifierPhone: "",
      verifierPrephone: "",
      // Verifier Errors
      verifierFirstNameErr: "",
      verifierLastNameErr: "",
      verifierEmailIdErr: "",
      verifierPhoneErr: "",

      // ERROR
      companyNameErr: "",
      companywebsiteErr: "",
      industryIdErr: "",
      yearOfEstablishmentErr: "",
      companyAdd1Err: "",
      companyAdd2Err: "",
      cityErr: "",
      regstateErr: "",
      countryIdErr: "",
      contactPersonErr: "",
      designationErr: "",
      emailIdErr: "",
      phoneErr: "",

      invcompanyNameErr: "",
      invcompanywebsiteErr: "",
      invindustryIdErr: "",
      invyearOfEstablishmentErr: "",
      invcompanyAdd1Err: "",
      invcompanyAdd2Err: "",
      invcityErr: "",
      invregstateErr: "",
      invcountryIdErr: "",
      invcontactPersonErr: "",
      invdesignationErr: "",
      invemailIdErr: "",
      invphoneErr: "",
      isOpen: true,
      //cms
      cmsSectionData: [],
      cmsMenuData: [],
      cmsFooterData: [],
      isFormSubmitted: false,
   
    };
    this.sameAsCorrespondenceClick = this.sameAsCorrespondenceClick.bind(this);
    this.getFillList = this.getFillList.bind(this);
    this.insertCompanyProfile = this.insertCompanyProfile.bind(this);
    this.onCountrySelect = this.onCountrySelect.bind(this);
    this.onIndustrySelect = this.onIndustrySelect.bind(this);
    this.getDetails = this.getDetails.bind(this);
    this.getIncompleteDetails = this.getIncompleteDetails.bind(this);
  }

  // loadscript() {
  //     $(document).ready(function () {
  //         $(this).scrollTop(0);
  //     });
  // }

  async componentDidMount() {
    // const isTimeout = await this.getCountDownDate();
    // console.log("isTimeout-->", isTimeout);
    // if (isTimeout) {
    //     this.props.navigate('/')
    // } else {
    window.scrollTo(0, 0);
    sessionStorage.setItem("currentPage", "companyProfile");
    this.getFillList(countryActionId, "", "", "", "").then(() => {
      this.getFillList(industryActionId, "", "", "", "").then(() => {
        this.getFillList(stateActionId, "", 91, "", "").then(() => {
          this.getFillList(cityActionId, "", 91, "", "").then(() => {
            console.log("prop is :", this.props);
            if (this.props.location.pathname.includes("/companyProfile/")) {
              var code = this.props.location.pathname.replace(
                "/companyProfile/",
                ""
              );
              console.log(
                "this.props.location.state",
                this.props.location.state,
                code
              );
              // this.getPendingRegDetailsByCode(code).then(agentCode => {
              //     agentCode != null && sessionStorage.setItem("agentCode", agentCode)
              // })
              this.getIncompleteDetails(code);
            } else if (sessionStorage.getItem("MemberID") != null) {
              this.getDetails();
            } else {
              this.setState({ isLoading: false });
            }
          });
        });
      });
    });
    console.log("this.props", this.props);
    this.setState({
      isOpen:
        this.props.location != null && this.props.location.state != null
          ? this.props.location.state.isOpen
          : true,
    });

    // }
  }

  getCountDownDate() {
    const {} = this.state;
    this.setState({ isLoading: true });
    return this.props.countDownDate_action().then((data) => {
      if (data.error != 1) {
        if (data.data.length > 0) {
          const LaunchDate = data.data[0]["countDownDate"];
          const targetDate = moment.utc(LaunchDate);
          // Current date in UTC
          const currentDate = moment();
          const split = currentDate.format().split("+");
          const updateCurrentDate = split[0] + "Z";
          const totalSeconds = targetDate.diff(updateCurrentDate, "seconds");
          return totalSeconds > 0;
        }
        this.setState({ isLoading: false });
      }
      this.setState({ isLoading: false });
      if (data.error == 1) toastError(data.data.ErrorMsg);
      return false;
    });
  }

  getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
    this.setState({ isLoading: true });
    return new Promise((resolve, reject) => {
      this.props
        .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
        .then((data) => {
          if (data.error != 1) {
            if (actionID === countryActionId) {
              this.setState({ countryList: data.data });
              resolve(true);
            } else if (actionID === stateActionId) {
              data.data.length > 0 &&
                this.setState({
                  stateList: data.data,
                  tempStateList: data.data,
                });
              resolve(true);
            } else if (actionID === cityActionId) {
              data.data.length > 0 &&
                this.setState({
                  cityList: data.data,
                  tempCityList: data.data,
                });
              resolve(true);
            } else if (actionID === industryActionId) {
              this.setState({
                industryList: data.data,
                // tempCityList: data.data,
              });
              resolve(true);
            }
          }
        });
    });
  }
  // Methods for handling verifier detail
  validateEmail = (email) => {
    if (!email) return "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) ? "" : "Invalid Email";
  };

  
  getDetails() {
    const { namePrefix, AccountID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getMemberRegistration_action(
        AccountID,
        parseInt(sessionStorage.getItem("MemberID"))
      )
      .then((data) => {
        console.log(data);
        if (data.error != 1) {
          var phn = data.data["PhoneNumber"];
          const parts = phn != "" ? phn.split("-") : "";
          const Mob1Code = parts.length > 1 && parts != "" ? parts[0] : "";
          const Mob1No =
            parts != "" ? (parts.length > 1 ? parts[1] : parts[0]) : "";
          var invPhn = data.data["INVPhoneNumber"];
          const parts3 = invPhn != "" ? invPhn.split("-") : "";
          const invMob1Code =
            parts3.length > 1 && parts3 != "" ? parts3[0] : "";
          const invMob1No =
            parts3 != "" ? (parts3.length > 1 ? parts3[1] : parts3[0]) : "";

          if (data.data.CountryID == 91) {
            this.getFillList(stateActionId, "", data.data.CountryID, "", "");
            this.getFillList(cityActionId, "", data.data.CountryID, "", "");
          }
          this.setState(
            {
              prename: namePrefix.includes(data.data["Title"])
                ? data.data["Title"]
                : "Other",
              isOtherPreName: namePrefix.includes(data.data["Title"])
                ? false
                : true,
              otherName: namePrefix.includes(data.data["Title"])
                ? ""
                : data.data["Title"],
              invprename: namePrefix.includes(data.data["INVTitle"])
                ? data.data["INVTitle"]
                : "Other",
              invisOtherPreName: namePrefix.includes(data.data["INVTitle"])
                ? false
                : true,
              invotherName: namePrefix.includes(data.data["INVTitle"])
                ? ""
                : data.data["INVTitle"],
              prephone: Mob1Code,
              phone: Mob1No,
              invprephone: invMob1Code,
              invphone: invMob1No,
              MemberID: data.data.MemberID,
              MembershipNo: data.data.MembershipNo,
              companyName: data.data.CompanyName,
              companywebsite: data.data.CompanyWebsite,
              industryId: data.data.IndustryID,
              yearOfEstablishment: data.data.EstablishmentYear,
              companyAdd1: data.data.Address1,
              companyAdd2: data.data.Address2,
              city: data.data.City,
              regstate: data.data.State,
              countryId: data.data.CountryID,
              contactPerson: data.data.ContactPersonName,
              designation: data.data.ContactPersonDesignation,
              emailId: data.data.EmailAddress,
              sameAsCorrespondence: data.data.SameAsCorrespondance,
              invcompanyName: data.data.INVCompanyName,
              invcompanywebsite: data.data.INVCompanyWebsite,
              invindustryId: data.data.INVIndustryID,
              invyearOfEstablishment: data.data.INVEstablishmentYear,
              invcompanyAdd1: data.data.INVAddress1,
              invcompanyAdd2: data.data.INVAddress2,
              invcity: data.data.INVCity,
              invregstate: data.data.INVState,
              invcountryId: data.data.INVCountryID,
              invcontactPerson: data.data.INVContactPersonName,
              invdesignation: data.data.INVContactPersonDesignation,
              invemailId: data.data.INVEmailAddress,
            },
            () => {
              console.log(this.state.sameAsCorrespondence);
              this.setState({ isLoading: false });
            }
          );
        } else {
          this.setState({ isLoading: false });
          toastError(data.data.ErrorMsg);
        }
      });
  }

  getIncompleteDetails(code) {
    const { namePrefix, AccountID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getIncompleteMemberRegistration_action(AccountID, code)
      .then((data) => {
        if (data.error != 1) {
          console.log(data.data, "consoleeeeee");
          sessionStorage.setItem("countryId", data.data.CountryID);
          sessionStorage.setItem("MemberID", data.data.MemberID);
          if (
            data.data.MembershipFormStatusID == 3 &&
            data.data.MembershipStatusID == 2
          ) {
            this.setState({
              isLoading: false,
              isOpen: false,
              isFormSubmitted: true,
            });
            return;
          }
       
          var phn = data.data["PhoneNumber"];
          const parts = phn ? phn.split("-") : [];
          const Mob1Code = parts.length > 1 ? parts[0] : "";
          const Mob1No = parts.length > 1 ? parts[1] : parts[0] || "";

          var invPhn = data.data["INVPhoneNumber"];
          const parts3 = invPhn ? invPhn.split("-") : [];
          const invMob1Code = parts3.length > 1 ? parts3[0] : "";
          const invMob1No = parts3.length > 1 ? parts3[1] : parts3[0] || "";

          this.setState(
            {
              prename: namePrefix.includes(data.data["Title"])
                ? data.data["Title"]
                : "Other",
              isOtherPreName: namePrefix.includes(data.data["Title"])
                ? false
                : true,
              otherName: namePrefix.includes(data.data["Title"])
                ? ""
                : data.data["Title"],
              invprename: namePrefix.includes(data.data["INVTitle"])
                ? data.data["INVTitle"]
                : "Other",
              invisOtherPreName: namePrefix.includes(data.data["INVTitle"])
                ? false
                : true,
              invotherName: namePrefix.includes(data.data["INVTitle"])
                ? ""
                : data.data["INVTitle"],
              prephone: Mob1Code,
              phone: Mob1No,
              invprephone: invMob1Code,
              invphone: invMob1No,
              MemberID: data.data.MemberID,
              MembershipNo: data.data.MembershipNo,
              companyName: data.data.CompanyName,
              companywebsite: data.data.CompanyWebsite,
              industryId: data.data.IndustryID,
              yearOfEstablishment: data.data.EstablishmentYear,
              companyAdd1: data.data.Address1,
              companyAdd2: data.data.Address2,
              city: data.data.City,
              regstate: data.data.State,
              countryId: data.data.CountryID,
              contactPerson: data.data.ContactPersonName,
              designation: data.data.ContactPersonDesignation,
              emailId: data.data.EmailAddress,
              sameAsCorrespondence: data.data.SameAsCorrespondance,
              invcompanyName: data.data.INVCompanyName,
              invcompanywebsite: data.data.INVCompanyWebsite,
              invindustryId: data.data.INVIndustryID,
              invyearOfEstablishment: data.data.INVEstablishmentYear,
              invcompanyAdd1: data.data.INVAddress1,
              invcompanyAdd2: data.data.INVAddress2,
              invcity: data.data.INVCity,
              invregstate: data.data.INVState,
              invcountryId: data.data.INVCountryID,
              invcontactPerson: data.data.INVContactPersonName,
              invdesignation: data.data.INVContactPersonDesignation,
              invemailId: data.data.INVEmailAddress,
           
            },
            () => {
              console.log(this.state.sameAsCorrespondence);

              // this.setState({ isLoading: false })
              this.getFillList(
                stateActionId,
                "",
                data.data.CountryID,
                "",
                ""
              ).then(() => {
                this.getFillList(
                  cityActionId,
                  "",
                  data.data.CountryID,
                  "",
                  ""
                ).then(() => {
                  this.setState({ isLoading: false });
                });
              });
            }
          );
        } else {
          this.setState({ isLoading: false });
          toastError(data.data.ErrorMsg);
        }
      });
  }

  insertCompanyProfile() {
    const {
      isLoading,
      countryList,
      companyName,
      companywebsite,
      industryId,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      invcompanyName,
      invcompanywebsite,
      invindustryId,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcountryId,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      prename,
      isOtherPreName,
      otherName,
      invisOtherPreName,
      invotherName,
      invprename,
      isOpenDropDownState,
      prephone,
      invprephone,
      focusedIndexState,
      isOpenDropDownCity,
      focusedIndexCity,
      tempStateList,
      tempCityList,
      stateList,
      cityList,
      companyNameErr,
      companywebsiteErr,
      industryIdErr,
      yearOfEstablishmentErr,
      companyAdd1Err,
      companyAdd2Err,
      cityErr,
      regstateErr,
      countryIdErr,
      contactPersonErr,
      designationErr,
      emailIdErr,
      phoneErr,
      invcompanyNameErr,
      invcompanywebsiteErr,
      invindustryIdErr,
      invyearOfEstablishmentErr,
      invcompanyAdd1Err,
      stateId,
      invcompanyAdd2Err,
      invcityErr,
      invregstateErr,
      invcountryIdErr,
      invcontactPersonErr,
      invdesignationErr,
      invemailIdErr,
      invphoneErr,
      MemberID,
      MembershipNo,
      AccountID,
    } = this.state;
    this.inputValidation().then((res) => {
      var stateErr = true;
      var stateID = null;
      if (countryId == 91) {
        for (var i = 0; i < stateList.length; i++) {
          if (
            this.state.regstate.toLowerCase() ==
            stateList[i].Description.toLowerCase()
          ) {
            stateErr = false;
            stateID = stateList[i].Code;
          }
        }
      } else {
        stateErr = false;
      }
      if (!res) {
        if (!stateErr) {
          this.setState({ isLoading: true });

          this.props
            .insertMemberRegistration_action(
              MemberID,
              MembershipNo,
              companyName,
              companywebsite,
              industryId,
              yearOfEstablishment,
              companyAdd1,
              companyAdd2,
              city,
              regstate,
              countryId,
              isOtherPreName ? otherName : prename,
              contactPerson,
              designation,
              emailId,
              prephone != null && prephone != ""
                ? `${prephone}-${phone}`
                : phone,
              sameAsCorrespondence,
              invcompanyName,
              invcompanywebsite,
              invindustryId,
              invyearOfEstablishment,
              invcompanyAdd1,
              invcompanyAdd2,
              invcity,
              invregstate,
              invcountryId,
              invisOtherPreName ? invotherName : invprename,
              invcontactPerson,
              invdesignation,
              invemailId,
              invprephone != null && invprephone != ""
                ? `${invprephone}-${invphone}`
                : invphone,
            )
            .then((data) => {
              if (data.error != 1) {
                if (data.data.ErrorMsg == null) {
                  sessionStorage.setItem("countryId", countryId);
                  sessionStorage.setItem("stateId", stateID);
                  sessionStorage.setItem("MemberID", data.data.MemberID);
                  this.props.navigate("/buisnessDetails");
                  sessionStorage.setItem("currentPage", "buisnessDetails");
                } else {
                  this.setState({ isLoading: false });
                  toastError(data.data.ErrorMsg);
                }
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.setState({
            regstateErr: "Please enter proper state",
          });
          toastError("Please enter mandatory fields");
        }
      } else {
        toastError("Please enter mandatory fields");
      }
    });
  }

  inputValidation() {
    const {
      isLoading,
      countryList,
      invemailIdErr,
      companyName,
      emailIdErr,
      companywebsite,
      industryId,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      invcompanyName,
      invcompanywebsite,
      invindustryId,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcountryId,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      prename,
      isOtherPreName,
      otherName,
      invisOtherPreName,
      invotherName,
      invprename,
      isOpenDropDownState,
      prephone,
      invprephone,
      focusedIndexState,
      isOpenDropDownCity,
      focusedIndexCity,
      tempStateList,
      tempCityList,
      stateList,
      cityList,
    } = this.state;
    var Err = false;
    return new Promise((resolve, reject) => {
      if (companyName == "" || companyName == null) {
        Err = true;
        this.setState({ companyNameErr: "Please enter Company Name" });
      }
      // if (companywebsite == '' || companywebsite == null) {
      //     Err = true
      //     this.setState({ companywebsiteErr: 'Please enter Company Website' })
      // }
      // if (industryId == '' || industryId == null) {
      //     Err = true
      //     this.setState({ industryIdErr: 'Please select industry' })
      // }
      if (yearOfEstablishment == "" || yearOfEstablishment == null) {
        Err = true;
        this.setState({
          yearOfEstablishmentErr: "Please enter Year of Establishment",
        });
      }
      if (companyAdd1 == "" || companyAdd1 == null) {
        Err = true;
        this.setState({
          companyAdd1Err: "Please enter Company Headquarters Address 1",
        });
      }
      if (companyAdd2 == "" || companyAdd2 == null) {
        Err = true;
        this.setState({
          companyAdd2Err: "Please enter Company Headquarters Address 2",
        });
      }
      if (city == "" || city == null) {
        Err = true;
        this.setState({ cityErr: "Please enter City" });
      }
      if (regstate == "" || regstate == null) {
        Err = true;
        this.setState({ regstateErr: "Please enter State" });
      }
      if (countryId == "" || countryId == null) {
        Err = true;
        this.setState({ countryIdErr: "Please select Country" });
      }
      if (contactPerson == "" || contactPerson == null) {
        Err = true;
        this.setState({ contactPersonErr: "Please enter Contact Person" });
      }
      if (designation == "" || designation == null) {
        Err = true;
        this.setState({ designationErr: "Please enter Designation" });
      }
      if (emailId == "" || emailId == null) {
        Err = true;
        this.setState({ emailIdErr: "Please enter Email" });
      } else {
        var ErrMsg = emailValidator(emailId);
        if (ErrMsg != "") {
          Err = true;
          this.setState({ emailIdErr: ErrMsg });
        }
      }
      if (emailIdErr != "" && emailIdErr != null) {
        Err = true;
      }
      if (phone == "" || phone == null) {
        Err = true;
        this.setState({ phoneErr: "Please enter Phone No." });
      }
      // INVVVVV
      if (invcompanyName == "" || invcompanyName == null) {
        Err = true;
        this.setState({
          invcompanyNameErr: "Please enter Invoice Company Name",
        });
      }
      // if (invcompanywebsite == '' || invcompanywebsite == null) {
      //     Err = true
      //     this.setState({ invcompanywebsiteErr: 'Please enter invoice Company Website' })
      // }
      // if (invindustryId == '' || invindustryId == null) {
      //     Err = true
      //     this.setState({ invindustryIdErr: 'Please select invoice industry' })
      // }
      if (invyearOfEstablishment == "" || invyearOfEstablishment == null) {
        Err = true;
        this.setState({
          invyearOfEstablishmentErr:
            "Please enter invoice Year of Establishment",
        });
      }
      if (invcompanyAdd1 == "" || invcompanyAdd1 == null) {
        Err = true;
        this.setState({
          invcompanyAdd1Err:
            "Please enter invoice Company Headquarters Address 1",
        });
      }
      if (invcompanyAdd2 == "" || invcompanyAdd2 == null) {
        Err = true;
        this.setState({
          invcompanyAdd2Err:
            "Please enter invoice Company Headquarters Address 2",
        });
      }
      if (invcity == "" || invcity == null) {
        Err = true;
        this.setState({ invcityErr: "Please enter invoice City" });
      }
      if (invregstate == "" || invregstate == null) {
        Err = true;
        this.setState({ invregstateErr: "Please enter invoice State" });
      }
      if (invcountryId == "" || invcountryId == null) {
        Err = true;
        this.setState({ invcountryIdErr: "Please select invoice Country" });
      }
      if (invcontactPerson == "" || invcontactPerson == null) {
        Err = true;
        this.setState({
          invcontactPersonErr: "Please enter invoice Contact Person",
        });
      }
      if (invdesignation == "" || invdesignation == null) {
        Err = true;
        this.setState({
          invdesignationErr: "Please enter invoice Designation",
        });
      }
      if (invemailId == "" || invemailId == null) {
        Err = true;
        this.setState({ invemailIdErr: "Please enter  invoice Email" });
      } else {
        var ErrMsg = emailValidator(invemailId);
        if (ErrMsg != "") {
          Err = true;
          this.setState({ invemailIdErr: ErrMsg });
        }
      }
      if (invemailIdErr != "" && invemailIdErr != null) {
        Err = true;
      }
      if (invphone == "" || invphone == null) {
        Err = true;
        this.setState({ invphoneErr: "Please enter invoice Phone No." });
      }

      resolve(Err);
    });
  }

  sameAsCorrespondenceClick() {
    const {
      isLoading,
      countryList,
      companyName,
      companywebsite,
      industryId,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      invcompanyName,
      invcompanywebsite,
      invindustryId,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcountryId,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      prename,
      isOtherPreName,
      otherName,
      invisOtherPreName,
      invotherName,
      invprename,
      isOpenDropDownState,
      prephone,
      invprephone,
      focusedIndexState,
      isOpenDropDownCity,
      focusedIndexCity,
      tempStateList,
      tempCityList,
      stateList,
      cityList,
      companyNameErr,
      companywebsiteErr,
      industryIdErr,
      yearOfEstablishmentErr,
      companyAdd1Err,
      companyAdd2Err,
      cityErr,
      regstateErr,
      countryIdErr,
      contactPersonErr,
      designationErr,
      emailIdErr,
      phoneErr,
      invcompanyNameErr,
      invcompanywebsiteErr,
      invindustryIdErr,
      invyearOfEstablishmentErr,
      invcompanyAdd1Err,
      invcompanyAdd2Err,
      invcityErr,
      invregstateErr,
      invcountryIdErr,
      invcontactPersonErr,
      invdesignationErr,
      invemailIdErr,
      invphoneErr,
    } = this.state;
    this.setState({ sameAsCorrespondence: !sameAsCorrespondence }, () => {
      if (sameAsCorrespondence == false) {
        this.setState({
          invcompanyName: companyName,
          invcompanywebsite: companywebsite,
          invindustryId: industryId,
          invyearOfEstablishment: yearOfEstablishment,
          invcompanyAdd1: companyAdd1,
          invcompanyAdd2: companyAdd2,
          invcity: city,
          invregstate: regstate,
          invcountryId: countryId,
          invcontactPerson: contactPerson,
          invdesignation: designation,
          invemailId: emailId,
          invphone: phone,
          invisOtherPreName: isOtherPreName,
          invotherName: otherName,
          invprename: prename,
          invprephone: prephone,
          invcompanyNameErr: "",
          invcompanywebsiteErr: "",
          invindustryIdErr: "",
          invyearOfEstablishmentErr: "",
          invcompanyAdd1Err: "",
          invcompanyAdd2Err: "",
          invcityErr: "",
          invregstateErr: "",
          invcountryIdErr: "",
          invcontactPersonErr: "",
          invdesignationErr: "",
          invemailIdErr: "",
          invphoneErr: "",
        });
      }
      if (sameAsCorrespondence == true) {
        this.setState({
          invcompanyName: "",
          invcompanywebsite: "",
          invindustryId: "",
          invyearOfEstablishment: "",
          invcompanyAdd1: "",
          invcompanyAdd2: "",
          invcity: "",
          invregstate: "",
          invcountryId: 91,
          invcontactPerson: "",
          invdesignation: "",
          invemailId: "",
          invphone: "",
          invisOtherPreName: false,
          invotherName: "",
          invprename: "Mr",
          invprephone: "",
          invcompanyNameErr: "",
          invcompanywebsiteErr: "",
          invindustryIdErr: "",
          invyearOfEstablishmentErr: "",
          invcompanyAdd1Err: "",
          invcompanyAdd2Err: "",
          invcityErr: "",
          invregstateErr: "",
          invcountryIdErr: "",
          invcontactPersonErr: "",
          invdesignationErr: "",
          invemailIdErr: "",
          invphoneErr: "",
        });
      }
    });
  }

  handleSearchChange = (event, mode, status) => {
    if (mode == 0) {
      if (status == 0) {
        this.setState({
          regstate: event.target.value,
          isOpenDropDownState: event.target.value.length > 0,
          tempStateList: this.filterItems(event.target.value, mode, status),
          focusedIndexState: -1,
          regstateErr: "",
          stateId: "",
        });
      } else if (status == 1) {
        this.setState({
          invregstate: event.target.value,
          invisOpenDropDownState: event.target.value.length > 0,
          tempStateList: this.filterItems(event.target.value, mode, status),
          invfocusedIndexState: -1,
          invregstateErr: "",
        });
      }
    } else if (mode == 1) {
      if (status == 0) {
        this.setState({
          city: event.target.value,
          isOpenDropDownCity: event.target.value.length > 0,
          tempCityList: this.filterItems(event.target.value, mode, status),
          focusedIndexCity: -1,
          cityErr: "",
        });
      } else if (status == 1) {
        this.setState({
          invcity: event.target.value,
          invisOpenDropDownCity: event.target.value.length > 0,
          tempCityList: this.filterItems(event.target.value, mode, status),
          invfocusedIndexCity: -1,
          invcityErr: "",
        });
      }
    }
  };

  filterItems = (searchTerm, mode, status) => {
    if (mode == 0) {
      if (status == 0) {
        return this.state.stateList.filter((item) =>
          item.Description.toLowerCase().includes(searchTerm.toLowerCase())
        );
      } else if (status == 1) {
        return this.state.stateList.filter((item) =>
          item.Description.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
    } else if (mode == 1) {
      if (status == 0) {
        return this.state.cityList.filter((item) =>
          item.Description.toLowerCase().includes(searchTerm.toLowerCase())
        );
      } else if (status == 1) {
        return this.state.cityList.filter((item) =>
          item.Description.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
    }
  };

  handleSelect = (option, mode, status) => {
    console.log(option.Description);
    if (mode == 0) {
      if (status == 0) {
        this.setState(
          {
            regstate: option.Description,
            focusedIndexState: -1,
            tempStateList: [],
            isOpenDropDownState: false,
            stateId: option.Code,
          },
          () => {
            // this.callStateList(option.Description, option.Code)
          }
        );
      } else if (status == 1) {
        this.setState(
          {
            invregstate: option.Description,
            invfocusedIndexState: -1,
            tempStateList: [],
            invisOpenDropDownState: false,
          },
          () => {
            // this.callStateList(option.Description, option.Code)
          }
        );
      }
    } else if (mode == 1) {
      if (status == 0) {
        this.setState({
          city: option.Description,
          focusedIndexCity: -1,
          tempCityList: [],
          isOpenDropDownCity: false,
        });
      } else if (status == 1) {
        this.setState({
          invcity: option.Description,
          invfocusedIndexCity: -1,
          tempCityList: [],
          invisOpenDropDownCity: false,
        });
      }
    }
  };

  handleKeyDown = (e, mode, status) => {
    const {
      focusedIndexState,
      tempPincodeList,
      tempPincodeListModal,
      focusedIndexPin,
      focusedIndexPinModal,
      tempStateList,
      focusedIndexStateModal,
      tempStateListModal,
      tempCityList,
      focusedIndexCity,
      focusedIndexCityModal,
      tempCityListModal,
      invfocusedIndexCity,
      invfocusedIndexState,
    } = this.state;
    if (mode == 0) {
      if (status == 0) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              focusedIndexState: Math.min(
                focusedIndexState + 1,
                tempStateList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              focusedIndexState: Math.max(focusedIndexState - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && focusedIndexState >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempStateList[focusedIndexState], mode, status);
        }
      } else if (status == 1) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              invfocusedIndexState: Math.min(
                invfocusedIndexState + 1,
                tempStateList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              invfocusedIndexState: Math.max(invfocusedIndexState - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && invfocusedIndexState >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempStateList[invfocusedIndexState], mode, status);
        }
      }
    } else if (mode == 1) {
      if (status == 0) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              focusedIndexCity: Math.min(
                focusedIndexCity + 1,
                tempCityList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              focusedIndexCity: Math.max(focusedIndexCity - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && focusedIndexCity >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempCityList[focusedIndexCity], mode, status);
        }
      } else if (status == 1) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          // Move focus down
          this.setState(
            {
              invfocusedIndexCity: Math.min(
                invfocusedIndexCity + 1,
                tempCityList.length - 1
              ),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          // Move focus up
          this.setState(
            {
              invfocusedIndexCity: Math.max(invfocusedIndexCity - 1, 0),
            },
            () => this.scrollIntoView(mode, status)
          );
        } else if (e.key === "Enter" && invfocusedIndexCity >= 0) {
          // Select the focused item when Enter is pressed
          this.handleSelect(tempCityList[invfocusedIndexCity], mode, status);
        }
      }
    }
  };

  handleHover = (index, mode, status) => {
    if (mode == 0) {
      if (status == 0) {
        this.setState({ focusedIndexState: index });
      } else if (status == 1) {
        this.setState({ invfocusedIndexState: index });
      }
    } else if (mode == 1) {
      if (status == 0) {
        this.setState({ focusedIndexCity: index });
      } else if (status == 1) {
        this.setState({ invfocusedIndexCity: index });
      }
    }
  };

  scrollIntoView = (mode, status) => {
    // console.log(mode, status)
    const {
      focusedIndexState,
      focusedIndexStateModal,
      invfocusedIndexCity,
      invfocusedIndexState,
      focusedIndexPin,
      focusedIndexPinModal,
      focusedIndexCity,
      focusedIndexCityModal,
    } = this.state;
    if (mode == 0) {
      if (status == 0) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[focusedIndexState];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      } else if (status == 1) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[invfocusedIndexState];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      }
    } else if (mode == 1) {
      if (status == 0) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[focusedIndexCity];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      } else if (status == 1) {
        const dropdownMenu = document.querySelector(".dropdown-menu"); // Get the dropdown menu
        if (!dropdownMenu) return;

        const focusedItem = dropdownMenu.children[invfocusedIndexCity];
        if (!focusedItem) return;

        // Scroll the dropdown menu if the focused item is not fully visible
        const dropdownTop = dropdownMenu.getBoundingClientRect().top;
        const dropdownBottom = dropdownMenu.getBoundingClientRect().bottom;
        const itemTop = focusedItem.getBoundingClientRect().top;
        const itemBottom = focusedItem.getBoundingClientRect().bottom;
        const menuTop = dropdownMenu.scrollTop;
        const menuHeight = dropdownMenu.offsetHeight;
        console.log("+++++++++++++++++++++++++++++x");
        console.log(dropdownTop);
        console.log(dropdownBottom);
        console.log(itemTop);
        console.log(itemBottom);
        console.log(menuTop);
        console.log(menuHeight);

        // Check if the focused item is outside the visible area and adjust the scroll
        if (itemBottom > dropdownBottom) {
          dropdownMenu.scrollTop = menuTop + itemBottom - dropdownBottom;
        } else if (itemTop < dropdownTop) {
          dropdownMenu.scrollTop = menuTop + (itemTop - dropdownTop);
        }
      }
    }
  };

  onCountrySelect(e, status) {
    const { countryList } = this.state;
    var countryId = e.target.value;
    if (status == 1) {
      this.setState({
        countryId: countryId,
        countryIdErr: "",
        phone: "",
        phoneErr: "",
      });
      var countryCode =
        countryId != ""
          ? countryList.filter((obj) => obj.Code == countryId)[0].CountryCode
          : "";
      this.setState({
        prephone: `+${countryCode}`,
      });
    } else {
      this.setState({
        invcountryId: countryId,
        invcountryIdErr: "",
        invphone: "",
        invphoneErr: "",
      });
      var countryCode =
        countryId != ""
          ? countryList.filter((obj) => obj.Code == countryId)[0].CountryCode
          : "";
      this.setState({
        invprephone: `+${countryCode}`,
      });
    }
    this.setState({
      regstateErr: "",
      cityErr: "",
    });
    this.getFillList(stateActionId, "", countryId, "", "").then(() => {
      this.getFillList(cityActionId, "", countryId, "", "").then(() => {
        this.setState({ isLoading: false });
      });
    });
  }

  onIndustrySelect(e, status) {
    // const {  } = this.state
    var industry = e.target.value;
    if (status == 1) {
      this.setState({ industryId: industry, industryIdErr: "" });
    } else {
      this.setState({ invindustryId: industry, invindustryIdErr: "" });
    }
  }

  onEmailInput(value, mode) {
    var ErrMsg = emailValidator(value);
    if (mode == 1) {
      this.setState({
        invemailIdErr: ErrMsg,
      });
    } else {
      this.setState({
        emailIdErr: ErrMsg,
      });
    }
  }

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  preventMinus = (e) => {
    (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault();
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text/plain");
    const sanitizedValue = pastedValue.replace(/[-.eE]/g, ""); // Remove '-', '.', 'e', 'E' characters

    // Replace the input value with the sanitized value
    document.execCommand("insertText", false, sanitizedValue);

    event.preventDefault(); // Prevent the default paste behavior
  };

  render() {
    const {
      isLoading,
      countryList,
      companyName,
      companywebsite,
      yearOfEstablishment,
      companyAdd1,
      companyAdd2,
      city,
      regstate,
      countryId,
      contactPerson,
      designation,
      emailId,
      phone,
      sameAsCorrespondence,
      invcompanyName,
      invcompanywebsite,
      invyearOfEstablishment,
      invcompanyAdd1,
      invcompanyAdd2,
      invcity,
      invregstate,
      invcontactPerson,
      invdesignation,
      invemailId,
      invphone,
      prename,
      isOtherPreName,
      otherName,
      invisOtherPreName,
      invotherName,
      invprename,
      isOpenDropDownState,
      prephone,
      invprephone,
      isOpenDropDownCity,
      tempStateList,
      tempCityList,
      companyNameErr,
      yearOfEstablishmentErr,
      companyAdd1Err,
      companyAdd2Err,
      cityErr,
      regstateErr,
      countryIdErr,
      contactPersonErr,
      designationErr,
      emailIdErr,
      phoneErr,
      invcompanyNameErr,
      invyearOfEstablishmentErr,
      invcompanyAdd1Err,
      invcompanyAdd2Err,
      invcityErr,
      invregstateErr,
      invcountryIdErr,
      invcontactPersonErr,
      invdesignationErr,
      invemailIdErr,
      invphoneErr,
      invisOpenDropDownState,
      invisOpenDropDownCity,
      isOpen,
      cmsMenuData,
      cmsFooterData,
      isFormSubmitted,
    } = this.state;
    return (
      <>
        {isLoading ? (
          <Loader />
        ) : isFormSubmitted ? (
          <Modal
            show={isFormSubmitted}
            style={{ backdropFilter: "blur(1px)" }}
            size="md"
          >
            <Modal.Body>
              <h5
                className="modal-title py-2 fw-normal"
                id="staticBackdropLabel"
              >
                Form Already Submitted
              </h5>
            </Modal.Body>

            <Modal.Footer
              style={{ justifyContent: "right", padding: "5px 10px" }}
            >
              <button
                type="btn"
                className="btn btn-outline-primary px-4"
                onClick={() => this.props.navigate("/")}
                data-toggle="modal"
                data-target="#add_comment_modal"
              >
                {" "}
                Ok
              </button>
            </Modal.Footer>
          </Modal>
        ) : (
          <>
            {/* <ToastContainer />. */}
            <Header headerNavs={cmsMenuData} />
            <ToastContainer />
            <section class="registration_form">
              <div class="container">
                <div class="row mt-2">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-body custom_form_fields pt-3">
                        {/* <ToastContainer />. */}
                        <Header />
                        <ToastContainer />
                        <section class="registration_form">
                          <div class="container">
                            <div class="row mt-15">
                              <div class="col-md-12">
                                <div class="card">
                                  <div class="card-body custom_form_fields pt-3">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="md-stepper-horizontal orange">
                                          <div
                                            class="md-step active"
                                            id="first_div"
                                          >
                                            <div class="md-step-circle">
                                              <span>1</span>
                                            </div>
                                            <div class="md-step-title">
                                              Company Profile
                                            </div>
                                            <div class="md-step-bar-left"></div>
                                            <div class="md-step-bar-right"></div>
                                          </div>
                                          <div class="md-step" id="second_div">
                                            <div class="md-step-circle">
                                              <span>2</span>
                                            </div>
                                            <div class="md-step-title">
                                              Business Details
                                            </div>
                                            <div class="md-step-bar-left"></div>
                                            <div class="md-step-bar-right"></div>
                                          </div>
                                          <div class="md-step" id="third_div">
                                            <div class="md-step-circle">
                                              <span>3</span>
                                            </div>
                                            <div class="md-step-title">
                                              Payment
                                            </div>
                                            <div class="md-step-bar-left"></div>
                                            <div class="md-step-bar-right"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="custom_tabs" id="mytabs">
                                          <div class="tab-content">
                                            <div
                                              class="tab-pane active"
                                              id="Company_Profile_tab"
                                              role="tabpanel"
                                              aria-labelledby="Company_Profile_tab"
                                              tabindex="0"
                                            >
                                              <fieldset>
                                                <legend>Company Profile</legend>

                                                <div class="row">
                                                  <div class="col-md-12">
                                                    <div class="row mb-3">
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Name
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Company name"
                                                            value={companyName}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                companyName:
                                                                  e.target
                                                                    .value,
                                                                companyNameErr:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invcompanyNameErr:
                                                                    e.target
                                                                      .value,
                                                                  invcompanyNameErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={1000}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {companyNameErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Website
                                                            {/* <span className="red-star text-danger">*</span> */}
                                                          </label>
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Company Website name"
                                                            value={
                                                              companywebsite
                                                            }
                                                            onChange={(e) => {
                                                              this.setState({
                                                                companywebsite:
                                                                  e.target
                                                                    .value,
                                                                companywebsiteErr:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invcompanywebsite:
                                                                    e.target
                                                                      .value,
                                                                  invcompanywebsiteErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={200}
                                                          />
                                                          {/* {<span className='text-danger text-start text-left d-block  ml-2'>{companywebsiteErr}</span>} */}
                                                        </div>
                                                      </div>
                                                      {/* <div class="col-md-3">
                                                                                <div class="form-group">
                                                                                    <label>Industry<span className="red-star text-danger">*</span></label>
                                                                                    <select className="form-control" value={industryId}
                                                                                        onChange={(e) => this.onIndustrySelect(e, 1)}
                                                                                    >
                                                                                        <option value={''}>Select Industry</option>
                                                                                        {
                                                                                            industryList.length > 0 && industryList.map((data) => (
                                                                                                <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block  ml-2'>{industryIdErr}</span>}
                                                                            </div> */}
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Year of
                                                            Establishment
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="number"
                                                            onInput={(e) =>
                                                              this.maxLengthCheck(
                                                                e,
                                                                20
                                                              )
                                                            }
                                                            class="form-control"
                                                            placeholder="Year of Establishment"
                                                            value={
                                                              yearOfEstablishment
                                                            }
                                                            onChange={(e) => {
                                                              this.setState({
                                                                yearOfEstablishment:
                                                                  e.target
                                                                    .value,
                                                                yearOfEstablishmentErr:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invyearOfEstablishment:
                                                                    e.target
                                                                      .value,
                                                                  invyearOfEstablishmentErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={20}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                yearOfEstablishmentErr
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Headquarters
                                                            Address 1
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>{" "}
                                                          </label>
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Address line 1"
                                                            value={companyAdd1}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                companyAdd1:
                                                                  e.target
                                                                    .value,
                                                                companyAdd1Err:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invcompanyAdd1:
                                                                    e.target
                                                                      .value,
                                                                  invcompanyAdd1Err:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={400}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {companyAdd1Err}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Headquarters
                                                            Address 2
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Address line 2"
                                                            value={companyAdd2}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                companyAdd2:
                                                                  e.target
                                                                    .value,
                                                                companyAdd2Err:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invcompanyAdd2:
                                                                    e.target
                                                                      .value,
                                                                  invcompanyAdd2Err:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={400}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {companyAdd2Err}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Country
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <select
                                                            className="form-control"
                                                            value={countryId}
                                                            disabled
                                                            onChange={(e) => {
                                                              this.onCountrySelect(
                                                                e,
                                                                1
                                                              );
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.onCountrySelect(
                                                                  e,
                                                                  2
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            <option value={""}>
                                                              Select Your
                                                              Country
                                                            </option>
                                                            {countryList.length >
                                                              0 &&
                                                              countryList.map(
                                                                (data) => (
                                                                  <option
                                                                    key={
                                                                      data.Code
                                                                    }
                                                                    value={
                                                                      data.Code
                                                                    }
                                                                  >
                                                                    {
                                                                      data.Description
                                                                    }
                                                                  </option>
                                                                )
                                                              )}
                                                          </select>
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {countryIdErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            City
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <Form.Control
                                                            type="text"
                                                            // placeholder="Search..."
                                                            value={city}
                                                            onChange={(e) => {
                                                              const value =
                                                                e.target.value;
                                                              const isValid =
                                                                /^[a-zA-Z\s]+$/.test(
                                                                  value
                                                                ) ||
                                                                value === "";

                                                              if (isValid) {
                                                                this.handleSearchChange(
                                                                  e,
                                                                  1,
                                                                  0
                                                                );
                                                                if (
                                                                  sameAsCorrespondence
                                                                ) {
                                                                  this.handleSearchChange(
                                                                    e,
                                                                    1,
                                                                    1
                                                                  );
                                                                }
                                                              }
                                                            }}
                                                            // onChange={this.handleSearchChange}
                                                            onFocus={() =>
                                                              city.length > 0 &&
                                                              this.setState({
                                                                isOpenDropDownCity: true,
                                                              })
                                                            }
                                                            // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                            onBlur={() =>
                                                              setTimeout(() => {
                                                                this.setState({
                                                                  isOpenDropDownCity: false,
                                                                });
                                                              }, 500)
                                                            }
                                                            onKeyDown={(e) =>
                                                              this.handleKeyDown(
                                                                e,
                                                                1,
                                                                0
                                                              )
                                                            }
                                                            placeholder="Enter City"
                                                            maxLength={100}
                                                          />

                                                          {/* Dropdown options - shown only if there are results */}
                                                          {isOpenDropDownCity &&
                                                            tempCityList.length >
                                                              0 && (
                                                              <Dropdown.Menu
                                                                show
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  width: "100%",
                                                                  zIndex: 1,
                                                                  maxHeight:
                                                                    "200px",
                                                                  overflowY:
                                                                    "auto",
                                                                  padding: 0,
                                                                }}
                                                              >
                                                                {tempCityList.map(
                                                                  (
                                                                    item,
                                                                    index
                                                                  ) => (
                                                                    <Dropdown.Item
                                                                      key={
                                                                        index
                                                                      }
                                                                      onClick={() => {
                                                                        this.handleSelect(
                                                                          item,
                                                                          1,
                                                                          0
                                                                        );
                                                                        if (
                                                                          sameAsCorrespondence
                                                                        ) {
                                                                          this.handleSelect(
                                                                            item,
                                                                            1,
                                                                            1
                                                                          );
                                                                        }
                                                                      }}
                                                                      // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                      style={{
                                                                        whiteSpace:
                                                                          "normal",
                                                                        height:
                                                                          "40px",
                                                                        wordWrap:
                                                                          "break-word",
                                                                        overflowWrap:
                                                                          "break-word",
                                                                        cursor:
                                                                          "pointer",
                                                                        transition:
                                                                          "none",
                                                                        backgroundColor:
                                                                          this
                                                                            .state
                                                                            .focusedIndexCity ===
                                                                          index
                                                                            ? "#744587"
                                                                            : "transparent",
                                                                        color:
                                                                          this
                                                                            .state
                                                                            .focusedIndexCity ===
                                                                          index
                                                                            ? "white"
                                                                            : "black",
                                                                      }}
                                                                      onMouseEnter={() =>
                                                                        this.handleHover(
                                                                          index,
                                                                          1,
                                                                          0
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.Description
                                                                      }
                                                                    </Dropdown.Item>
                                                                  )
                                                                )}
                                                              </Dropdown.Menu>
                                                            )}
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {cityErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            State
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <Form.Control
                                                            type="text"
                                                            // placeholder="Search..."
                                                            value={regstate}
                                                            onChange={(e) => {
                                                              const value =
                                                                e.target.value;
                                                              const isValid =
                                                                /^[a-zA-Z\s]+$/.test(
                                                                  value
                                                                ) ||
                                                                value === "";

                                                              if (isValid) {
                                                                this.handleSearchChange(
                                                                  e,
                                                                  0,
                                                                  0
                                                                );
                                                                if (
                                                                  sameAsCorrespondence
                                                                ) {
                                                                  this.handleSearchChange(
                                                                    e,
                                                                    0,
                                                                    1
                                                                  );
                                                                }
                                                              }
                                                            }}
                                                            // onChange={this.handleSearchChange}
                                                            onFocus={() =>
                                                              regstate.length >
                                                                0 &&
                                                              this.setState({
                                                                isOpenDropDownState: true,
                                                              })
                                                            }
                                                            // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                            onBlur={() =>
                                                              setTimeout(() => {
                                                                this.setState({
                                                                  isOpenDropDownState: false,
                                                                });
                                                              }, 500)
                                                            }
                                                            onKeyDown={(e) =>
                                                              this.handleKeyDown(
                                                                e,
                                                                0,
                                                                0
                                                              )
                                                            }
                                                            placeholder="Enter State"
                                                            maxLength={100}
                                                          />

                                                          {/* Dropdown options - shown only if there are results */}
                                                          {isOpenDropDownState &&
                                                            tempStateList.length >
                                                              0 && (
                                                              <Dropdown.Menu
                                                                show
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  width: "100%",
                                                                  zIndex: 1,
                                                                  maxHeight:
                                                                    "200px",
                                                                  overflowY:
                                                                    "auto",
                                                                  padding: 0,
                                                                }}
                                                              >
                                                                {tempStateList.map(
                                                                  (
                                                                    item,
                                                                    index
                                                                  ) => (
                                                                    <Dropdown.Item
                                                                      key={
                                                                        index
                                                                      }
                                                                      onClick={() => {
                                                                        this.handleSelect(
                                                                          item,
                                                                          0,
                                                                          0
                                                                        );
                                                                        if (
                                                                          sameAsCorrespondence
                                                                        ) {
                                                                          this.handleSelect(
                                                                            item,
                                                                            0,
                                                                            1
                                                                          );
                                                                        }
                                                                      }}
                                                                      // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                      style={{
                                                                        whiteSpace:
                                                                          "normal",
                                                                        height:
                                                                          "40px",
                                                                        wordWrap:
                                                                          "break-word",
                                                                        overflowWrap:
                                                                          "break-word",
                                                                        cursor:
                                                                          "pointer",
                                                                        transition:
                                                                          "none",
                                                                        backgroundColor:
                                                                          this
                                                                            .state
                                                                            .focusedIndexState ===
                                                                          index
                                                                            ? "#744587"
                                                                            : "transparent",
                                                                        color:
                                                                          this
                                                                            .state
                                                                            .focusedIndexState ===
                                                                          index
                                                                            ? "white"
                                                                            : "black",
                                                                      }}
                                                                      onMouseEnter={() =>
                                                                        this.handleHover(
                                                                          index,
                                                                          0,
                                                                          0
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.Description
                                                                      }
                                                                    </Dropdown.Item>
                                                                  )
                                                                )}
                                                              </Dropdown.Menu>
                                                            )}
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {regstateErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Key Contact Person
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          {isOtherPreName && (
                                                            <input
                                                              type="text"
                                                              className="form-control-1"
                                                              // maxLength={}
                                                              value={otherName}
                                                              onChange={(e) => {
                                                                this.setState({
                                                                  otherName:
                                                                    e.target
                                                                      .value,
                                                                });
                                                                if (
                                                                  sameAsCorrespondence
                                                                ) {
                                                                  this.setState(
                                                                    {
                                                                      invotherName:
                                                                        e.target
                                                                          .value,
                                                                    }
                                                                  );
                                                                }
                                                              }}
                                                              placeholder={
                                                                "Other"
                                                              }
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                display:
                                                                  !isOtherPreName &&
                                                                  "none",
                                                                paddingLeft:
                                                                  "5px",
                                                                width: "45px",
                                                                top: "60px",
                                                                // color:'grey'
                                                              }}
                                                              maxLength={20}
                                                            />
                                                          )}
                                                          <div className="col-md-1">
                                                            <div
                                                              className="form-group"
                                                              style={{
                                                                width: 45,
                                                                position:
                                                                  "absolute",
                                                                left: 0,
                                                                zIndex: 1,
                                                                top: "28px",
                                                                fontSize:
                                                                  "12px",
                                                                // color:'grey'
                                                              }}
                                                            >
                                                              <label />
                                                              <select
                                                                className="form-control-1 select2 select-hidden-accessible"
                                                                id="validationCustom03"
                                                                required=""
                                                                style={{
                                                                  borderTop:
                                                                    "none",
                                                                  borderBottom:
                                                                    "none",
                                                                  marginTop: 2,
                                                                  borderRadius: 0,
                                                                  borderLeft: 0,
                                                                  height: 33,
                                                                  padding: 0,
                                                                  color: "grey",
                                                                  background:
                                                                    "none",
                                                                }}
                                                                value={prename}
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  this.setState(
                                                                    {
                                                                      prename:
                                                                        e.target
                                                                          .value,
                                                                      isOtherPreName:
                                                                        e.target
                                                                          .value ==
                                                                          "Other" &&
                                                                        true,
                                                                    }
                                                                  );
                                                                  if (
                                                                    sameAsCorrespondence
                                                                  ) {
                                                                    this.setState(
                                                                      {
                                                                        invprename:
                                                                          e
                                                                            .target
                                                                            .value,
                                                                        invisOtherPreName:
                                                                          e
                                                                            .target
                                                                            .value ==
                                                                            "Other" &&
                                                                          true,
                                                                      }
                                                                    );
                                                                  }
                                                                }}
                                                              >
                                                                <option value="Mr">
                                                                  Mr
                                                                </option>
                                                                <option value="Ms">
                                                                  Ms
                                                                </option>
                                                                <option value="DR">
                                                                  DR
                                                                </option>
                                                                <option value="Prof">
                                                                  Prof
                                                                </option>
                                                                <option value="Other">
                                                                  Other
                                                                </option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                          <input
                                                            type="text"
                                                            style={{
                                                              position:
                                                                "relative",
                                                              paddingLeft: 55,
                                                            }}
                                                            class="form-control"
                                                            placeholder="Contact Person"
                                                            value={
                                                              contactPerson
                                                            }
                                                            onChange={(e) => {
                                                              this.setState({
                                                                contactPerson:
                                                                  e.target
                                                                    .value,
                                                                contactPersonErr:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invcontactPerson:
                                                                    e.target
                                                                      .value,
                                                                  invcontactPersonErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={200}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {contactPersonErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Position/Title/Designation
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Contact person designation"
                                                            value={designation}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                designation:
                                                                  e.target
                                                                    .value,
                                                                designationErr:
                                                                  "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invdesignation:
                                                                    e.target
                                                                      .value,
                                                                  invdesignationErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            maxLength={100}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {designationErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Email Id
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="email"
                                                            class="form-control"
                                                            placeholder="Enter Email"
                                                            value={emailId}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                emailId:
                                                                  e.target
                                                                    .value,
                                                                emailIdErr: "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invemailId:
                                                                    e.target
                                                                      .value,
                                                                  invemailIdErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                            onBlur={(e) =>
                                                              this.onEmailInput(
                                                                e.target.value,
                                                                0
                                                              )
                                                            }
                                                            maxLength={100}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {emailIdErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Phone Number
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="text"
                                                            className="form-control-1"
                                                            value={prephone}
                                                            placeholder="ISD"
                                                            maxLength={"11"}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                prephone:
                                                                  e.target
                                                                    .value,
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invprephone:
                                                                    e.target
                                                                      .value,
                                                                });
                                                              }
                                                            }}
                                                            style={{
                                                              width: 55,
                                                              position:
                                                                "absolute",
                                                              // top: 30,
                                                              textAlign:
                                                                "center",
                                                              padding:
                                                                " 6px !important",
                                                              paddingLeft:
                                                                prephone == ""
                                                                  ? 10
                                                                  : 0,
                                                              borderLeft: 0,
                                                              borderTop: 0,
                                                              background:
                                                                "none",
                                                              borderBottom: 0,
                                                              height: 34,
                                                              zIndex:
                                                                isOpenDropDownState
                                                                  ? 0
                                                                  : 10,
                                                              color: "grey",
                                                            }}
                                                          />
                                                          <input
                                                            type="number"
                                                            class="form-control"
                                                            placeholder="Enter Phone no"
                                                            style={{
                                                              position:
                                                                "relative",
                                                              paddingLeft: 65,
                                                            }}
                                                            maxLength={
                                                              countryId == 91
                                                                ? "10"
                                                                : "20"
                                                            }
                                                            onInput={(e) =>
                                                              this.maxLengthCheck(
                                                                e,
                                                                10
                                                              )
                                                            }
                                                            onKeyDown={(e) =>
                                                              this.preventMinus(
                                                                e
                                                              )
                                                            }
                                                            onPaste={(e) =>
                                                              this.handlePaste(
                                                                e
                                                              )
                                                            }
                                                            onWheel={(e) =>
                                                              e.target.blur()
                                                            }
                                                            value={phone}
                                                            onChange={(e) => {
                                                              this.setState({
                                                                phone:
                                                                  e.target
                                                                    .value,
                                                                phoneErr: "",
                                                              });
                                                              if (
                                                                sameAsCorrespondence
                                                              ) {
                                                                this.setState({
                                                                  invphone:
                                                                    e.target
                                                                      .value,
                                                                  invphoneErr:
                                                                    "",
                                                                });
                                                              }
                                                            }}
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {phoneErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    {/* <div class="row mb-3"> */}
                                                    {/* </div> */}
                                                  </div>
                                                </div>
                                              </fieldset>

                                              <fieldset>
                                                <legend>Invoice Details</legend>

                                                <div class="row mb-3">
                                                  <div class="col-md-12">
                                                    <div class="form-group float-right">
                                                      <div
                                                        class="custom-control custom-checkbox"
                                                        onClick={(e) =>
                                                          this.sameAsCorrespondenceClick()
                                                        }
                                                      >
                                                        <input
                                                          type="checkbox"
                                                          class="custom-control-input"
                                                          checked={
                                                            sameAsCorrespondence
                                                          }
                                                          value={
                                                            sameAsCorrespondence
                                                          }
                                                        />
                                                        <label
                                                          class="custom-control-label"
                                                          for="Correspondence_Details"
                                                        >
                                                          Same as Correspondence
                                                          Details
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="row">
                                                  <div class="col-md-12">
                                                    <div class="row mb-3">
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Name
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            maxLength={1000}
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Company name"
                                                            value={
                                                              invcompanyName
                                                            }
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invcompanyName:
                                                                  e.target
                                                                    .value,
                                                                invcompanyNameErr:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                invcompanyNameErr
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Website
                                                            {/* <span className="red-star text-danger">*</span> */}
                                                          </label>
                                                          <input
                                                            maxLength={200}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Company Website name"
                                                            value={
                                                              invcompanywebsite
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invcompanywebsite:
                                                                  e.target
                                                                    .value,
                                                                invcompanywebsiteErr:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {/* {<span className='text-danger text-start text-left d-block  ml-2'>{invcompanywebsiteErr}</span>} */}
                                                        </div>
                                                      </div>
                                                      {/* <div class="col-md-3">
                                                                                <div class="form-group">
                                                                                    <label>Industry<span className="red-star text-danger">*</span></label>
                                                                                    <select disabled={sameAsCorrespondence} className="form-control" value={invindustryId}
                                                                                        onChange={(e) => this.onIndustrySelect(e, 2)}
                                                                                    >
                                                                                        <option value={''}>Select Industry</option>
                                                                                        {
                                                                                            industryList.length > 0 && industryList.map((data) => (
                                                                                                <option key={data.Code} value={data.Code} >{data.Description}</option>
                                                                                            ))
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block  ml-2'>{invindustryIdErr}</span>}
                                                                            </div> */}
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Year of
                                                            Establishment
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            maxLength={20}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="number"
                                                            onInput={(e) =>
                                                              this.maxLengthCheck(
                                                                e,
                                                                20
                                                              )
                                                            }
                                                            class="form-control"
                                                            placeholder="Year of Establishment"
                                                            value={
                                                              invyearOfEstablishment
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invyearOfEstablishment:
                                                                  e.target
                                                                    .value,
                                                                invyearOfEstablishmentErr:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                invyearOfEstablishmentErr
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Headquarters
                                                            Address 1
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>{" "}
                                                          </label>
                                                          <input
                                                            maxLength={400}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Address line 1"
                                                            value={
                                                              invcompanyAdd1
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invcompanyAdd1:
                                                                  e.target
                                                                    .value,
                                                                invcompanyAdd1Err:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                invcompanyAdd1Err
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Company Headquarters
                                                            Address 2
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            maxLength={400}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Address line 2"
                                                            value={
                                                              invcompanyAdd2
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invcompanyAdd2:
                                                                  e.target
                                                                    .value,
                                                                invcompanyAdd2Err:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                invcompanyAdd2Err
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Country
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <select
                                                            disabled
                                                            className="form-control"
                                                            value={countryId}
                                                            onChange={(e) =>
                                                              this.onCountrySelect(
                                                                e,
                                                                2
                                                              )
                                                            }
                                                          >
                                                            <option value={""}>
                                                              Select Your
                                                              Country
                                                            </option>
                                                            {countryList.length >
                                                              0 &&
                                                              countryList.map(
                                                                (data) => (
                                                                  <option
                                                                    key={
                                                                      data.Code
                                                                    }
                                                                    value={
                                                                      data.Code
                                                                    }
                                                                  >
                                                                    {
                                                                      data.Description
                                                                    }
                                                                  </option>
                                                                )
                                                              )}
                                                          </select>
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {invcountryIdErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            City
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <Form.Control
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            // placeholder="Search..."
                                                            value={invcity}
                                                            onChange={(e) =>
                                                              !/^[a-zA-Z\s]+$/.test(
                                                                e.target.value
                                                              ) &&
                                                              e.target.value !=
                                                                ""
                                                                ? null
                                                                : this.handleSearchChange(
                                                                    e,
                                                                    1,
                                                                    1
                                                                  )
                                                            }
                                                            // onChange={this.handleSearchChange}
                                                            onFocus={() =>
                                                              invcity.length >
                                                                0 &&
                                                              this.setState({
                                                                invisOpenDropDownCity: true,
                                                              })
                                                            }
                                                            // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                            onBlur={() =>
                                                              setTimeout(() => {
                                                                this.setState({
                                                                  invisOpenDropDownCity: false,
                                                                });
                                                              }, 500)
                                                            }
                                                            onKeyDown={(e) =>
                                                              this.handleKeyDown(
                                                                e,
                                                                1,
                                                                1
                                                              )
                                                            }
                                                            placeholder="Enter City"
                                                            maxLength={100}
                                                          />

                                                          {/* Dropdown options - shown only if there are results */}
                                                          {invisOpenDropDownCity &&
                                                            tempCityList.length >
                                                              0 && (
                                                              <Dropdown.Menu
                                                                show
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  width: "100%",
                                                                  zIndex: 1,
                                                                  maxHeight:
                                                                    "200px",
                                                                  overflowY:
                                                                    "auto",
                                                                  padding: 0,
                                                                }}
                                                              >
                                                                {tempCityList.map(
                                                                  (
                                                                    item,
                                                                    index
                                                                  ) => (
                                                                    <Dropdown.Item
                                                                      key={
                                                                        index
                                                                      }
                                                                      onClick={() =>
                                                                        this.handleSelect(
                                                                          item,
                                                                          1,
                                                                          1
                                                                        )
                                                                      }
                                                                      // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                      style={{
                                                                        whiteSpace:
                                                                          "normal",
                                                                        height:
                                                                          "40px",
                                                                        wordWrap:
                                                                          "break-word",
                                                                        overflowWrap:
                                                                          "break-word",
                                                                        cursor:
                                                                          "pointer",
                                                                        transition:
                                                                          "none",
                                                                        backgroundColor:
                                                                          this
                                                                            .state
                                                                            .invfocusedIndexCity ===
                                                                          index
                                                                            ? "#744587"
                                                                            : "transparent",
                                                                        color:
                                                                          this
                                                                            .state
                                                                            .invfocusedIndexCity ===
                                                                          index
                                                                            ? "white"
                                                                            : "black",
                                                                      }}
                                                                      onMouseEnter={() =>
                                                                        this.handleHover(
                                                                          index,
                                                                          1,
                                                                          1
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.Description
                                                                      }
                                                                    </Dropdown.Item>
                                                                  )
                                                                )}
                                                              </Dropdown.Menu>
                                                            )}
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {invcityErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            State
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <Form.Control
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            // placeholder="Search..."
                                                            value={invregstate}
                                                            onChange={(e) =>
                                                              !/^[a-zA-Z\s]+$/.test(
                                                                e.target.value
                                                              ) &&
                                                              e.target.value !=
                                                                ""
                                                                ? null
                                                                : this.handleSearchChange(
                                                                    e,
                                                                    0,
                                                                    1
                                                                  )
                                                            }
                                                            // onChange={this.handleSearchChange}
                                                            onFocus={() =>
                                                              invregstate.length >
                                                                0 &&
                                                              this.setState({
                                                                invisOpenDropDownState: true,
                                                              })
                                                            }
                                                            // onBlur={() => this.setState({ isOpenDropDownCity: false })}
                                                            onBlur={() =>
                                                              setTimeout(() => {
                                                                this.setState({
                                                                  invisOpenDropDownState: false,
                                                                });
                                                              }, 500)
                                                            }
                                                            onKeyDown={(e) =>
                                                              this.handleKeyDown(
                                                                e,
                                                                0,
                                                                1
                                                              )
                                                            }
                                                            placeholder="Enter State"
                                                            maxLength={100}
                                                          />

                                                          {/* Dropdown options - shown only if there are results */}
                                                          {invisOpenDropDownState &&
                                                            tempStateList.length >
                                                              0 && (
                                                              <Dropdown.Menu
                                                                show
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  width: "100%",
                                                                  zIndex: 1,
                                                                  maxHeight:
                                                                    "200px",
                                                                  overflowY:
                                                                    "auto",
                                                                  padding: 0,
                                                                }}
                                                              >
                                                                {tempStateList.map(
                                                                  (
                                                                    item,
                                                                    index
                                                                  ) => (
                                                                    <Dropdown.Item
                                                                      key={
                                                                        index
                                                                      }
                                                                      onClick={() =>
                                                                        this.handleSelect(
                                                                          item,
                                                                          0,
                                                                          1
                                                                        )
                                                                      }
                                                                      // className={this.state.focusedIndexCity === index ? 'text-white' : 'none'}
                                                                      style={{
                                                                        whiteSpace:
                                                                          "normal",
                                                                        height:
                                                                          "40px",
                                                                        wordWrap:
                                                                          "break-word",
                                                                        overflowWrap:
                                                                          "break-word",
                                                                        cursor:
                                                                          "pointer",
                                                                        transition:
                                                                          "none",
                                                                        backgroundColor:
                                                                          this
                                                                            .state
                                                                            .invfocusedIndexState ===
                                                                          index
                                                                            ? "#744587"
                                                                            : "transparent",
                                                                        color:
                                                                          this
                                                                            .state
                                                                            .invfocusedIndexState ===
                                                                          index
                                                                            ? "white"
                                                                            : "black",
                                                                      }}
                                                                      onMouseEnter={() =>
                                                                        this.handleHover(
                                                                          index,
                                                                          0,
                                                                          1
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        item.Description
                                                                      }
                                                                    </Dropdown.Item>
                                                                  )
                                                                )}
                                                              </Dropdown.Menu>
                                                            )}
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {invregstateErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Key Contact Person
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          {invisOtherPreName && (
                                                            <input
                                                              disabled={
                                                                sameAsCorrespondence
                                                              }
                                                              type="text"
                                                              className="form-control-1"
                                                              // maxLength={'40'}/
                                                              value={
                                                                invotherName
                                                              }
                                                              onChange={(e) =>
                                                                this.setState({
                                                                  invotherName:
                                                                    e.target
                                                                      .value,
                                                                })
                                                              }
                                                              placeholder={
                                                                "Other"
                                                              }
                                                              style={{
                                                                position:
                                                                  "absolute",
                                                                display:
                                                                  !invisOtherPreName &&
                                                                  "none",
                                                                paddingLeft:
                                                                  "5px",
                                                                width: "45px",
                                                                top: "60px",
                                                              }}
                                                              maxLength={20}
                                                            />
                                                          )}
                                                          <div className="col-md-1">
                                                            <div
                                                              className="form-group"
                                                              style={{
                                                                width: 45,
                                                                position:
                                                                  "absolute",
                                                                left: 0,
                                                                zIndex: 1,
                                                                top: "28px",
                                                                fontSize:
                                                                  "12px",
                                                              }}
                                                            >
                                                              <label />
                                                              <select
                                                                className="form-control-1 select2 select-hidden-accessible"
                                                                id="validationCustom03"
                                                                required=""
                                                                disabled={
                                                                  sameAsCorrespondence
                                                                }
                                                                style={{
                                                                  borderTop:
                                                                    "none",
                                                                  borderBottom:
                                                                    "none",
                                                                  marginTop: 2,
                                                                  borderRadius: 0,
                                                                  borderLeft: 0,
                                                                  height: 33,
                                                                  padding: 0,
                                                                  color: "grey",
                                                                  background:
                                                                    "none",
                                                                }}
                                                                value={
                                                                  invprename
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      invprename:
                                                                        e.target
                                                                          .value,
                                                                      invisOtherPreName:
                                                                        e.target
                                                                          .value ==
                                                                          "Other" &&
                                                                        true,
                                                                    }
                                                                  )
                                                                }
                                                              >
                                                                <option value="Mr">
                                                                  Mr
                                                                </option>
                                                                <option value="Ms">
                                                                  Ms
                                                                </option>
                                                                <option value="DR">
                                                                  DR
                                                                </option>
                                                                <option value="Prof">
                                                                  Prof
                                                                </option>
                                                                <option value="Other">
                                                                  Other
                                                                </option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                          <input
                                                            maxLength={200}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Contact Person"
                                                            style={{
                                                              position:
                                                                "relative",
                                                              paddingLeft: 55,
                                                            }}
                                                            value={
                                                              invcontactPerson
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invcontactPerson:
                                                                  e.target
                                                                    .value,
                                                                invcontactPersonErr:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                invcontactPersonErr
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Position/Title/Designation
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            maxLength={100}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="Enter Company name"
                                                            value={
                                                              invdesignation
                                                            }
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invdesignation:
                                                                  e.target
                                                                    .value,
                                                                invdesignationErr:
                                                                  "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {
                                                                invdesignationErr
                                                              }
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Email Id
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            maxLength={100}
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="email"
                                                            class="form-control"
                                                            placeholder="Enter Email"
                                                            value={invemailId}
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invemailId:
                                                                  e.target
                                                                    .value,
                                                                invemailIdErr:
                                                                  "",
                                                              })
                                                            }
                                                            onBlur={(e) =>
                                                              this.onEmailInput(
                                                                e.target.value,
                                                                1
                                                              )
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {invemailIdErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                      <div class="col-md-3">
                                                        <div class="form-group">
                                                          <label>
                                                            Phone Number
                                                            <span className="red-star text-danger">
                                                              *
                                                            </span>
                                                          </label>
                                                          <input
                                                            type="text"
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            className="form-control-1"
                                                            value={invprephone}
                                                            placeholder="ISD"
                                                            maxLength={"10"}
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invprephone:
                                                                  e.target
                                                                    .value,
                                                              })
                                                            }
                                                            style={{
                                                              width: 55,
                                                              position:
                                                                "absolute",
                                                              // top: 30,
                                                              textAlign:
                                                                "center",
                                                              padding:
                                                                " 6px !important",
                                                              paddingLeft:
                                                                invprephone ==
                                                                ""
                                                                  ? 10
                                                                  : 0,
                                                              borderLeft: 0,
                                                              borderTop: 0,
                                                              background:
                                                                "none",
                                                              borderBottom: 0,
                                                              height: 34,
                                                              zIndex:
                                                                invisOpenDropDownState
                                                                  ? 0
                                                                  : 10,
                                                              color: "grey",
                                                            }}
                                                          />
                                                          <input
                                                            disabled={
                                                              sameAsCorrespondence
                                                            }
                                                            type="number"
                                                            class="form-control"
                                                            placeholder="Enter Phone no"
                                                            style={{
                                                              position:
                                                                "relative",
                                                              paddingLeft: 65,
                                                            }}
                                                            maxLength={
                                                              countryId == 91
                                                                ? "10"
                                                                : "20"
                                                            }
                                                            onInput={(e) =>
                                                              this.maxLengthCheck(
                                                                e,
                                                                10
                                                              )
                                                            }
                                                            onKeyDown={(e) =>
                                                              this.preventMinus(
                                                                e
                                                              )
                                                            }
                                                            onPaste={(e) =>
                                                              this.handlePaste(
                                                                e
                                                              )
                                                            }
                                                            onWheel={(e) =>
                                                              e.target.blur()
                                                            }
                                                            value={invphone}
                                                            onChange={(e) =>
                                                              this.setState({
                                                                invphone:
                                                                  e.target
                                                                    .value,
                                                                invphoneErr: "",
                                                              })
                                                            }
                                                          />
                                                          {
                                                            <span className="text-danger text-start text-left d-block  ml-2">
                                                              {invphoneErr}
                                                            </span>
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    {/* <div class="row mb-3"> */}
                                                    {/* </div> */}
                                                  </div>
                                                </div>
                                              </fieldset>
                                             
                                              <div class="row">
                                                <div class="col-md-12 text-right">
                                                  <button
                                                    class="btn btn-primary next_btn"
                                                    onClick={() =>
                                                      this.insertCompanyProfile()
                                                    }
                                                  >
                                                    Next
                                                  </button>
                                                  {/* <a id="move_to_tab_2"></a> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Footer footerData={cmsFooterData} />

            <Modal
              show={isOpen}
              style={{ backdropFilter: "blur(1px)" }}
              size="md"
            >
              {/* <Modal.Header closeButton>
                        <Modal.Title>
                            <h5 className="modal-title" id="staticBackdropLabel">
                                <i class="fa fa-trash-o"></i><span style={{ marginLeft: '5px' }}>Delete</span>
                            </h5>
                        </Modal.Title>
                    </Modal.Header> */}
              <Modal.Body>
                <h5
                  className="modal-title py-2 fw-normal"
                  id="staticBackdropLabel"
                >
                  <ol>
                    <li>
                      {" "}
                      Keep your GST and PAN card documents ready for further
                      process.
                    </li>
                    <li>
                      {" "}
                      The registration charges are ₹7,000/- + applicable taxes.
                    </li>
                  </ol>
                </h5>
              </Modal.Body>

              <Modal.Footer
                style={{ justifyContent: "right", padding: "5px 10px" }}
              >
                <button
                  type="btn"
                  className="btn btn-outline-primary px-4"
                  onClick={() => this.setState({ isOpen: false })}
                  data-toggle="modal"
                  data-target="#add_comment_modal"
                >
                  {" "}
                  Ok
                </button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    insertMemberRegistration_action,
    fill_action,
    getIncompleteMemberRegistration_action,
    getMemberRegistration_action,
    countDownDate_action,
  })(CompanyProfile)
);
